// extracted by mini-css-extract-plugin
export var attachmentContainer = "_n2-0";
export var fileList = "_n2-2";
export var removeFileButton = "_n2-1";